import React    from 'react'
import { Link } from "react-router-dom";
import logo     from '../../resources/images/csa-logo.png';
import './page404.css'

const Page404 = () => (
  <div className="page-404">
    <div className="center">
      <h1 className="text-center title">404</h1>
      <h4 className="text-center description">Not Found</h4>
      <Link to="/"><img alt="CSA" style={{width: "300px"}} className="logo-404" src={logo}/></Link>
    </div>
  </div>
);

export default Page404;